import { memo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PlutoCard from "./PlutoCard";
import PlutoViewAllCard from "./PlutoViewAllCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import Translate from "../../../Components/MultiLanguage/Translate";

const PlutoCategories = memo(({ data, index = 0 }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isPortrait = data?.thumbnail_orientation === "PORTRAIT" || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT";
  
  const isContinueWatching = data?.type === "CONTINUE_WATCHING";
  const slidesPerView = isPortrait ? 8 : 6;

  return (
    <div className="pluto-categories-section">
      <div className="pluto-categories-container">
        <div className="pluto-categories-header">
          <h2 className="category-title">
            {data?.category_name}
          </h2>
          {/* {data?.shows?.length > slidesPerView && ( */}
            <Link to={`/category/${data?.key}?career=${data?.key}`} className="view-all">
              <Translate textKey={"view_all"} />
            </Link>
          {/* )} */}
        </div>

        <div className="pluto-categories-content">
            <div className="pluto-swiper-container">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  nextEl: `.swiper-button-next-${(data?.key || data?.type || index)?.toString().replace(/[^a-zA-Z0-9]/g, "-")}`,
                  prevEl: `.swiper-button-prev-${(data?.key || data?.type || index)?.toString().replace(/[^a-zA-Z0-9]/g, "-")}`,
                }}
                spaceBetween={5}
                slidesPerView={slidesPerView}
                slidesPerGroup={slidesPerView}
                watchSlidesProgress={true}
                speed={500}
                preventInteractionOnTransition={true}
                breakpoints={{
                  320: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 0 },
                  576: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 2 },
                  768: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 2 },
                  992: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 2 },
                  1200: { slidesPerView: slidesPerView, slidesPerGroup: slidesPerView, spaceBetween: 2 },
                }}
                className="pluto-categories-slider"
              >
                {data.shows.map((show, index) => (
                  <SwiperSlide key={`${show?.vanity_url || show?.id}-${index}`}>
                    <PlutoCard 
                      data={show} 
                      projectInfo={projectInfo} 
                      isWatching={isContinueWatching}
                    />
                  </SwiperSlide>
                ))}
                {data.shows.length >= 10 && (
                  <SwiperSlide key="view-all-card">
                    <PlutoViewAllCard 
                      link={`/category/${data?.key}?career=${data?.key}`}
                      isPortrait={isPortrait}
                    />
                  </SwiperSlide>
                )}
              </Swiper>
              <div className={`swiper-button-prev swiper-button-prev-${(data?.key || data?.type || index)?.toString().replace(/[^a-zA-Z0-9]/g, "-")}`}>
                <i className="fa fa-chevron-left"></i>
              </div>
              <div className={`swiper-button-next swiper-button-next-${(data?.key || data?.type || index)?.toString().replace(/[^a-zA-Z0-9]/g, "-")}`}>
                <i className="fa fa-chevron-right"></i>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
});

PlutoCategories.displayName = "PlutoCategories";
export default PlutoCategories;
